import type { BeforeRequestHook } from 'ky';
import { isServer } from '../../utils';
import type { HookGetterArgs } from '../types';

export const getServerAuthHeaders = ({
  fetchArgs: { url, method: _method, data: _data },
  baseURL: _baseURL,
}: HookGetterArgs): BeforeRequestHook => {
  const authHeadersHook: BeforeRequestHook = async (request) => {
    if (isServer() && url.startsWith('/')) {
      const { headers: nextHeaders } = await import('next/headers');
      const header = await nextHeaders();
      const reqCookie = header.get('cookie') ?? '';

      if (reqCookie) {
        request.headers.set('cookie', reqCookie);
      }
    }
  };
  return authHeadersHook;
};
